import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum GiftVoucherColorHex {
  PLUM = '#703367',
  BURGUNDY = '#8B1E3F',
  RED = '#C8102E',
  ORANGE = '#D9731A',
  GOLD = '#B8860B',
  OLIVE = '#6B7908',
  GREEN = '#2D841B',
  TEAL = '#058179',
  BLUE = '#2A439E',
  GRAPHITE = '#3C3C3C',
}

export class GiftVoucherColor extends Codebook<GiftVoucherColorHex> {
  static readonly PLUM = new GiftVoucherColor(GiftVoucherColorHex.PLUM, () => $t('Default'))
  static readonly BURGUNDY = new GiftVoucherColor(GiftVoucherColorHex.BURGUNDY, () =>
    $t('Burgundy'),
  )
  static readonly RED = new GiftVoucherColor(GiftVoucherColorHex.RED, () => $t('Red'))
  static readonly ORANGE = new GiftVoucherColor(GiftVoucherColorHex.ORANGE, () => $t('Orange'))
  static readonly GOLD = new GiftVoucherColor(GiftVoucherColorHex.GOLD, () => $t('Gold'))
  static readonly OLIVE = new GiftVoucherColor(GiftVoucherColorHex.OLIVE, () => $t('Olive'))
  static readonly GREEN = new GiftVoucherColor(GiftVoucherColorHex.GREEN, () => $t('Green'))
  static readonly TEAL = new GiftVoucherColor(GiftVoucherColorHex.TEAL, () => $t('Teal'))
  static readonly BLUE = new GiftVoucherColor(GiftVoucherColorHex.BLUE, () => $t('Blue'))
  static readonly GRAPHITE = new GiftVoucherColor(GiftVoucherColorHex.GRAPHITE, () =>
    $t('Graphite'),
  )

  private constructor(
    public readonly hex: GiftVoucherColorHex,
    public readonly label: () => string,
  ) {
    super(hex)
  }
}
